// Import react and router DOM
import React, { useContext, useState, useEffect } from "react";

//Import components
import CuttingDieModal from "./CuttingDieModal.jsx";
//Import states, contexts and CSS
import productionSheetContext from "../../../store/productionSheetContext.jsx";
import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";

// Gestione delle lingue
import { useTranslation } from "react-i18next";

const CuttingDieForm = () => {
  const { t } = useTranslation();

  const { bagDetailsInput, setBagDetailsInput, bagWeight } = useContext(
    productionSheetContext
  );
  const { responseDataOutput } = useContext(productionSheetContext) || {};

  const cuttingDieOutput = responseDataOutput?.cuttingDieOutput || 0;

  const { cuttingDieValue, cuttingDieCalc, cuttingDieWidth, cuttingDieHeight } =
    bagDetailsInput || "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setBagDetailsInput((prevData) => ({
      ...prevData,
      [name]: Number(value),
    }));
  };

  const handleCuttingDieCalcSwicth = () => {
    setBagDetailsInput((prevData) => ({
      ...prevData,
      cuttingDieCalc: !prevData.cuttingDieCalc,
      cuttingDieWidth: 0,
      cuttingDieHeight: 0,
    }));
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <hr />
      <Form>
        <Form.Check
          className="mb-2"
          type="checkbox"
          label={t("bagDetails.cuttingDieCalc")}
          checked={cuttingDieCalc}
          onChange={handleCuttingDieCalcSwicth}
        ></Form.Check>
      </Form>
      {cuttingDieCalc && (
        <>
          <Button onClick={() => setModalShow(true)}>Import Cutting Die</Button>
          <CuttingDieModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />

          <InputGroup
            controlId="cuttingDieWidth"
            className={"mb-2 d-flex align-items-center"}
          >
            <Form.Label className={"w-50"}>
              {t("bagDetails.cuttingDieWidth")}
            </Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder=""
              name="cuttingDieWidth"
              value={cuttingDieWidth || ""}

              onChange={handleChange}
              min={0}
              max={99}s
      
            ></Form.Control>
            <InputGroup.Text> Cm </InputGroup.Text>
          </InputGroup>
          <InputGroup
            controlId="cuttingDieWidth"
            className={"mb-2 d-flex align-items-center"}
          >
            <Form.Label className={"w-50"}>
              {t("bagDetails.cuttingDieHeight")}
            </Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder=""
              name="cuttingDieHeight"
              value={cuttingDieHeight || ""}
              onChange={handleChange}
              min={0}
              max={99}
      
            ></Form.Control>
            <InputGroup.Text> Cm </InputGroup.Text>
          </InputGroup>
        </>
      )}{" "}

      {!cuttingDieCalc && (

          <InputGroup
          controlId="cuttingDie"
          className={"mb-2 d-flex align-items-center"}
          >
        <Form.Label className={"w-50"}>{t("bagDetails.cuttingDie")}</Form.Label>
        <Form.Control
          className="text-end"
          type="number"
          placeholder=""
          name="cuttingDieValue"
          min={0}
          max={99}
          value={cuttingDieValue || ""}
          onChange={handleChange}
          disabled={cuttingDieCalc}
          ></Form.Control>
        <InputGroup.Text> % </InputGroup.Text>
      </InputGroup>
        )}

      { cuttingDieCalc && (
      <InputGroup
        controlId="cuttingDie"
        className={"mb-2 d-flex align-items-center"}
      >


        <Form.Label className={"w-50"}>{t("bagDetails.cuttingDie")}</Form.Label>
        <Form.Control
          className="text-end"
          type="number"
          placeholder=""
          name="cuttingDieOutput"
          min={0}
          max={99}
          value={cuttingDieOutput?.toFixed(1) || ""}
          disabled
          readOnly
          ></Form.Control>
        <InputGroup.Text> % </InputGroup.Text>
      </InputGroup>)
        }
    </>
  );
};

export default CuttingDieForm;
